import { ReactNode } from "react";

import { Paper, PaperProps, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

interface TileProps extends PaperProps {
  action?: ReactNode;
  featured?: boolean;
  overtitle?: string;
  text?: string;
  title?: string;
}

const PREFIX = "BaikiTile";
const classes = {
  root: `${PREFIX}-Root`,
  text: `${PREFIX}-Text`,
};

const Root = styled(Paper, {
  shouldForwardProp: (prop: string) => !["featured"].includes(prop),
})<TileProps>(({ featured, theme }) => ({
  alignItems: "center",
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.secondary,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  minHeight: "35vh",
  padding: theme.spacing(featured ? 4 : 3),
  position: "relative",
  textAlign: "center",
  [theme.breakpoints.up("sm")]: {
    borderRadius: (theme.shape.borderRadius as number) * 2,
    minHeight: "30vh",
  },
  [theme.breakpoints.up("md")]: {
    borderRadius: (theme.shape.borderRadius as number) * 3,
    padding: theme.spacing(featured ? 8 : 6),
  },
}));

export const Tile: React.FC<TileProps> = ({
  action,
  overtitle,
  text,
  title,
  variant = "outlined",
  ...props
}) => {
  return (
    <Root variant={variant} className={classes.root} {...props}>
      <Stack alignItems="center" spacing={{ xs: 1, sm: 1.5, md: 2 }}>
        {overtitle && (
          <Typography variant="overline" style={{ textWrap: "balance" }}>
            {overtitle}
          </Typography>
        )}
        {title && (
          <Typography
            color="primary.dark"
            style={{ textWrap: "balance" }}
            sx={{ textDecoration: "underline" }}
            variant="h2"
          >
            {title.replace(/["]+/g, "")}
          </Typography>
        )}
        {text && (
          <Typography
            align="center"
            color="text.secondary"
            style={{ textWrap: "balance" }}
            variant="body1"
          >
            {text}
          </Typography>
        )}
        {action && action}
      </Stack>
    </Root>
  );
};
